export default Logo;


import AjaxRequest from './Ajax';


function Logo(config) {

    function refresh(data,type) {


        if (data[0].actualDate) {

            let actualDate = data[0].actualDate;


            data.forEach(function (item) {
                if (item.map !== undefined) {
                    if (config.type === 'datasheet' && item.map.coordinates === undefined) {
                        var activeLayer = null;

                        item.map.layerTypeList.forEach((layer) => {
                            if (layer.active) {
                                activeLayer = layer.key;
                            }
                        });

                        if (activeLayer !== null) {
                            getData(activeLayer, data,type);
                        }
                    }
                }
            });

        }

    }


    function getData(selectedLayer, data,type) {

        let request = {
            url: config.ajaxUrl + '/logo',
            data: {
                action: 'logo',
                id: data[0].id,
                view_date: moment(data[0].actualDate).format('YYYY-MM-DD'),
                type: type,
            },
            success: function (response) {
                if (response.success && response.data !== undefined) {
                    data[0].logoUrl = response.data.logoUrl;
                }
            },
        };
        AjaxRequest(request);
    }


    return {
        refresh: refresh,
    };

}